export function getDuesOnboardingProgress({ members, products, subscriptions, invoices, payoutsReady }) {
    const hasAssignedDues = products.some((product) =>
        product.unit_id && product.dues_price?.length,
    );
    const hasRecurringBilling = subscriptions.some((subscription) =>
        ['active', 'trialing'].includes(subscription.status),
    );
    const hasSentInvoice = invoices.some((invoice) =>
        ['open', 'paid', 'uncollectible'].includes(invoice.status),
    );

    return {
        members: members.length > 0,
        dues: hasAssignedDues,
        payouts: payoutsReady,
        billing: hasRecurringBilling || hasSentInvoice,
    };
}
